export enum EstadoCivilEnum {
    Solteiro = 1,
    Casado = 2,
    Divorciado = 3,
    Separado = 4,
    Viúvo = 5
  }